export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'

export interface setCurrentCompany {
  type: typeof SET_CURRENT_COMPANY
  payload: string
}
